// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(status) {
  switch (status) {
    case "CANCELLED" :
        return /* Cancelled */1;
    case "DELIVERED" :
        return /* Delivered */3;
    case "PENDING" :
        return /* Pending */2;
    case "REQUESTED" :
        return /* Requested */0;
    default:
      return ErrorUtils$Catalyst.raiseError("DeliveryNoteStatus.res", "Invalid delivery note status", status);
  }
}

function toString(stauts) {
  switch (stauts) {
    case /* Requested */0 :
        return "REQUESTED";
    case /* Cancelled */1 :
        return "CANCELLED";
    case /* Pending */2 :
        return "PENDING";
    case /* Delivered */3 :
        return "DELIVERED";
    
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
